<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Notícia: {{ article.title }}</span>
      </h1>
    </div>
  </div>


  <div v-if="!loading" class="align p-4 space_title">
    <div class="card">
      <table>
        <thead>
          <tr>
            <th>Página</th>
            <th>Visitas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(page, key) in articlePages.data" :key="key">
            <td>
              {{ page.name }}
            </td>
            <td>
              {{ $numberFormat(page.views) }}
            </td>
          </tr>
          <tr class="no_result" v-if="!articlePages.data || (articlePages.data && !articlePages.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <ListPagination class="mt-4" :links="articlePages.meta.links" />
  </div>

</template>
  
<script setup>
import { useReportStore } from '@/stores/ReportStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject, onMounted, ref, watch } from 'vue';
import RedirectBack from '@/components/RedirectBack.vue';
import { useRoute } from 'vue-router';
import moment from 'moment';

const loader = inject('$loader');
const loading = ref(false);

const reportStore = useReportStore();
const { articlePages, article, filter } = storeToRefs(reportStore);

const route = useRoute();

onMounted(async () => {
  if (route.query.date_start) {
    filter.value.date_start = route.query.date_start;
    filter.value.date_end = route.query.date_end;
  }else {
    filter.value.date_start = moment().utcOffset(-3).format('YYYY-MM-DD');
    filter.value.date_end = moment().utcOffset(-3).format('YYYY-MM-DD');
  }

  loadPages();
});

async function loadPages() {
  const id = route.params.id;

  loader.show();
  loading.value = true;

  await reportStore.getArticle(id);

  let params = {
    page: parseInt(route.query.page),
    date_start: filter.value.date_start,
    date_end: filter.value.date_end
  };

  await reportStore.getArticlePages(id, params);
  loader.hide();
  loading.value = false;
}

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadPages();
  }
});
</script>@/stores/ReportStore